import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDE5Bn86DLaixpvA6XJORg1t_NSOVza4D8",
  authDomain: "sentrys-34ab8.firebaseapp.com",
  databaseURL: "https://sentrys-34ab8-default-rtdb.firebaseio.com",
  projectId: "sentrys-34ab8",
  storageBucket: "sentrys-34ab8.firebasestorage.app",
  messagingSenderId: "687866168609",
  appId: "1:687866168609:web:1f777216e3d546db98aa60",
  measurementId: "G-L0PF1JB2C6"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const sentrysDb = getFirestore(app, "sentrys");

// ✅ helper
async function getAuthToken() {
  const user = auth.currentUser;

  if (!user) {
    throw new Error("User not authenticated");
  }

  return await user.getIdToken();
}

export { app, auth, sentrysDb, getAuthToken };